import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { ChampionshipProvider } from '@/contexts/ChampionshipContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ChampionshipSelectorPage } from '@/pages/ChampionshipSelectorPage';
import { ChampionshipDetailPage } from '@/pages/ChampionshipDetailPage';
import { HomePage } from '@/pages/HomePage';
import { StandingsPage } from '@/pages/StandingsPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { MatchDetailPage } from '@/pages/MatchDetailPage';
import { MatchesByDatePage } from '@/pages/MatchesByDatePage';
import { FavoritesPage } from '@/pages/FavoritesPage';
import { SearchResultsPage } from '@/pages/SearchResultsPage';
import AdminPanel from '@/pages/AdminPanel';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ChampionshipProvider>
            <Routes>
              <Route path="/" element={<ChampionshipSelectorPage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/partite" element={<MatchesByDatePage />} />
              <Route path="/preferiti" element={<FavoritesPage />} />
              <Route path="/championship/:championshipId" element={<ChampionshipDetailPage />} />
              <Route path="/championship/:championshipId/home" element={<HomePage />} />
              <Route path="/championship/:championshipId/classifica" element={<StandingsPage />} />
              <Route path="/championship/:championshipId/calendario" element={<CalendarPage />} />
              <Route path="/championship/:championshipId/partita/:matchId" element={<MatchDetailPage />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </ChampionshipProvider>
        </BrowserRouter>
        <Toaster />
      </ThemeProvider>
    </div>
  );
}

export default App;
